// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.applicant-heart-rating {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  background-color: #FAFAFA;
  padding: 1rem;
  margin-bottom: 2rem;
}
/*# sourceMappingURL=index.css.map */`, "",{"version":3,"sources":["webpack://./index.less","webpack://./wp_components/ApplicantHeartRating/index.less"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;ACDJ;AACA,oCAAoC","sourcesContent":["@import \"../../less/variables.less\";\n\n.applicant-heart-rating {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1rem;\n    background-color: @secondary-25;\n    padding: 1rem;\n    margin-bottom: 2rem;\n}",".applicant-heart-rating {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  background-color: #FAFAFA;\n  padding: 1rem;\n  margin-bottom: 2rem;\n}\n/*# sourceMappingURL=index.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
